import React from 'react';
import { ReportQuestion, QuestionTypes, Question } from 'interface';
import { urlValidation } from 'scripts/validation';
import { extractFileName } from 'scripts/string';

export function answerItemNodeGenerator(questions: Question[], reportItem?: ReportQuestion[]) {
    return (
        <>
            {questions.map((question) => {
                if (question.input_type === QuestionTypes.camera) {
                    const report = reportItem?.find((i) => i.question.id === question.id);
                    return (
                        <span key={question.id}>
                            {report?.value && urlValidation(report.value.toString()) ? (
                                <a target="_blank" rel="noreferrer" href={report.value.toString()}>
                                    {extractFileName(report.value.toString())}
                                </a>
                            ) : (
                                ' - '
                            )}
                        </span>
                    );
                } else if (question.input_type === QuestionTypes.voice) {
                    const report = reportItem?.find((i) => i.question.id === question.id);
                    return (
                        <td key={question.id}>
                            {report?.value && urlValidation(report.value.toString()) ? (
                                <audio controls>
                                    <source src={report.value.toString()} />
                                </audio>
                            ) : (
                                ' - '
                            )}
                        </td>
                    );
                } else if (question.input_type === QuestionTypes.file) {
                    const report = reportItem?.find((i) => i.question.id === question.id);
                    let count = 0;
                    return (
                        <span key={question.id}>
                            {report?.value
                                ?.toString()
                                .split(',')
                                .map((item) => {
                                    if (urlValidation(item.trim())) {
                                        count++;
                                        return (
                                            <a target="_blank" rel="noreferrer" href={item.trim()}>
                                                {extractFileName(item.trim())}
                                            </a>
                                        );
                                    }
                                })}
                            {count === 0 ? ' - ' : null}
                        </span>
                    );
                } else if (question.input_type === QuestionTypes.emoji) {
                    const report = reportItem?.find((i) => i.question.id === question.id);
                    return (
                        <span key={question.id}>
                            {report && report.question_items
                                ? report.question_items
                                      .map((i) => i.title + ' ' + String.fromCodePoint(Number(i.value)))
                                      .join(',')
                                : ' - '}
                        </span>
                    );
                } else if (question.input_type === QuestionTypes.matrix) {
                    const report = reportItem?.find((i) => i.question.id === question.id);
                    return (
                        <span key={question.id}>
                            {report?.question_items && report.question_items.length
                                ? report.question_items
                                      .map((item) =>
                                          Number(item.value) === 1 ? item.title + ':' + report.value : item.title,
                                      )
                                      .join(', ')
                                : ' - '}
                        </span>
                    );
                } else if (
                    [
                        QuestionTypes.email,
                        QuestionTypes.phoneNumber,
                        QuestionTypes.mobileNumber,
                        QuestionTypes.nps,
                        QuestionTypes.number,
                        QuestionTypes.rate,
                        QuestionTypes.simple,
                        QuestionTypes.scale,
                        QuestionTypes.website,
                    ].includes(question.input_type)
                ) {
                    const report = reportItem?.find((i) => i.question.id === question.id);
                    return <span key={question.id}>{report?.value ? report.value : ' - '}</span>;
                } else if (
                    [
                        QuestionTypes.selective,
                        QuestionTypes.dropDown,
                        QuestionTypes.twoOptions,
                        QuestionTypes.pictureSelective,
                        QuestionTypes.matrix,
                    ].includes(question.input_type)
                ) {
                    const report = reportItem?.find((i) => i.question.id === question.id);
                    return (
                        <span key={question.id}>
                            {report?.question_items && report.question_items.length
                                ? report.question_items
                                      .map((item) =>
                                          Number(item.value) === 1 ? item.title + ':' + report.value : item.title,
                                      )
                                      .join(', ')
                                : ' - '}
                        </span>
                    );
                } else if (QuestionTypes.date === question.input_type) {
                    const report = reportItem?.find((i) => i.question.id === question.id);
                    return (
                        <span key={question.id}>
                            {report && report.value ? new Date(report.value).toLocaleDateString('fa') : ' - '}
                        </span>
                    );
                } else if (QuestionTypes.priority === question.input_type) {
                    let value = '';
                    const children: { title: string; order: number }[] = [];
                    question.children?.map((child) => {
                        const report = reportItem?.find((i) => i.question.id === child.id);
                        if (report) children.push({ title: report.question.title, order: Number(report.value) });
                    });
                    children
                        .sort((a, b) => a.order - b.order)
                        .map((child) => (value += `${child.order}- ${child?.title}\n`));
                    return (
                        <span key={question.id}>
                            {value.split('\n').map((item, index) => (
                                <p key={index}>{item.trim()}</p>
                            ))}
                        </span>
                    );
                } else {
                    return <span key={question.id}>Unsupported question type!</span>;
                }
            })}
        </>
    );
}
